import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

// SDD §5: /admin/login is a PUBLIC sibling of AdminLayout — auth guard
// must NOT wrap it or the user can't reach the login form. The rest of
// /admin/* are children of AdminLayout and require a token.
const Login = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Login.vue')
const Layout = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Layout.vue')
const Dashboard = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Dashboard.vue')
const ScenariosList = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Scenarios/List.vue')
const ScenarioDetail = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Scenarios/Detail.vue')
const CountryCodes = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/CountryCodes.vue')
const Audit = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Audit.vue')
const Account = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Account.vue')

const routes = [
  { path: '/', name: 'demo', component: () => import('@/views/DemoView.vue') },
  { path: '/admin/login', name: 'admin-login', component: Login, meta: { public: true } },
  {
    path: '/admin',
    component: Layout,
    children: [
      { path: '', name: 'admin-dashboard', component: Dashboard },
      { path: 'scenarios', name: 'admin-scenarios', component: ScenariosList },
      {
        path: 'scenarios/:id',
        name: 'admin-scenario-detail',
        component: ScenarioDetail,
        props: true,
        children: [
          {
            path: 'prompts',
            name: 'admin-scenario-prompts',
            component: () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Scenarios/Prompts/List.vue'),
            props: true
          },
          {
            path: 'prompts/:language',
            name: 'admin-scenario-prompt-editor',
            component: () => import(/* webpackChunkName: "admin" */ '@/views/Admin/Scenarios/Prompts/Editor.vue'),
            props: true
          }
        ]
      },
      { path: 'country-codes', name: 'admin-country-codes', component: CountryCodes },
      { path: 'audit', name: 'admin-audit', component: Audit },
      { path: 'account', name: 'admin-account', component: Account }
    ]
  }
]

const router = new VueRouter({ mode: 'history', routes })

router.beforeEach((to, _from, next) => {
  if (!to.path.startsWith('/admin')) return next()
  if (to.meta && to.meta.public) return next()
  if (store.state.adminAuth && store.state.adminAuth.token) return next()
  return next({ name: 'admin-login', query: { redirect: to.fullPath } })
})

export default router
